 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"article":"article","article-reimport":"article-reimport","articles":"articles","cache":"cache","explorer":"explorer","explorer-single":"explorer-single","explorer-single-spotlight":"explorer-single-spotlight","featured":"featured","featured-apps~featured-main~featured-sub":"featured-apps~featured-main~featured-sub","featured-apps":"featured-apps","featured-main":"featured-main","featured-sub":"featured-sub","feed":"feed","feed-articles":"feed-articles","feed-fixture":"feed-fixture","feed-fixtures":"feed-fixtures","feed-logs":"feed-logs","feed-settings":"feed-settings","feed-videos":"feed-videos","feeds":"feeds","history":"history","history-single":"history-single","logout":"logout","new-feed":"new-feed","page-new":"page-new","page-single":"page-single","pages":"pages","rounds":"rounds","tools":"tools","topic":"topic","topics":"topics","video":"video","video-reimport":"video-reimport","videos":"videos","weights":"weights"}[chunkId]||chunkId) + "." + {"article":"ee3cbb12","article-reimport":"3643c328","articles":"c3db3761","cache":"13692477","explorer":"3d2a46dc","explorer-single":"f7fdd81e","explorer-single-spotlight":"7aaefaf6","featured":"d539cbe9","featured-apps~featured-main~featured-sub":"2a116872","featured-apps":"65223dab","featured-main":"450e733f","featured-sub":"93125cdd","feed":"21d4a145","feed-articles":"be697cd5","feed-fixture":"60f2c4e8","feed-fixtures":"b30539cb","feed-logs":"1f56f155","feed-settings":"8629bfe3","feed-videos":"44e9c881","feeds":"5a5cec9e","history":"9126ffae","history-single":"1501abec","logout":"ea8f73e3","new-feed":"a3923401","page-new":"32439889","page-single":"efaf2563","pages":"852a6355","rounds":"425e13fd","tools":"21246689","topic":"53a2349c","topics":"65ed9062","video":"ed8782b4","video-reimport":"6448b967","videos":"512154de","weights":"7b543e6b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"explorer-single":1,"explorer-single-spotlight":1,"featured-apps":1,"featured-main":1,"featured-sub":1,"feed":1,"feed-articles":1,"feed-fixture":1,"feed-fixtures":1,"feed-logs":1,"feed-videos":1,"feeds":1,"tools":1,"topic":1,"topics":1,"weights":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"article":"article","article-reimport":"article-reimport","articles":"articles","cache":"cache","explorer":"explorer","explorer-single":"explorer-single","explorer-single-spotlight":"explorer-single-spotlight","featured":"featured","featured-apps~featured-main~featured-sub":"featured-apps~featured-main~featured-sub","featured-apps":"featured-apps","featured-main":"featured-main","featured-sub":"featured-sub","feed":"feed","feed-articles":"feed-articles","feed-fixture":"feed-fixture","feed-fixtures":"feed-fixtures","feed-logs":"feed-logs","feed-settings":"feed-settings","feed-videos":"feed-videos","feeds":"feeds","history":"history","history-single":"history-single","logout":"logout","new-feed":"new-feed","page-new":"page-new","page-single":"page-single","pages":"pages","rounds":"rounds","tools":"tools","topic":"topic","topics":"topics","video":"video","video-reimport":"video-reimport","videos":"videos","weights":"weights"}[chunkId]||chunkId) + "." + {"article":"31d6cfe0","article-reimport":"31d6cfe0","articles":"31d6cfe0","cache":"31d6cfe0","explorer":"31d6cfe0","explorer-single":"30c8bfd5","explorer-single-spotlight":"30c8bfd5","featured":"31d6cfe0","featured-apps~featured-main~featured-sub":"31d6cfe0","featured-apps":"8fe29441","featured-main":"1449aa34","featured-sub":"c5b16414","feed":"220a772d","feed-articles":"d210e8b1","feed-fixture":"2b70a061","feed-fixtures":"ab109eb2","feed-logs":"308279bf","feed-settings":"31d6cfe0","feed-videos":"e8ba2dc3","feeds":"f9b61f90","history":"31d6cfe0","history-single":"31d6cfe0","logout":"31d6cfe0","new-feed":"31d6cfe0","page-new":"31d6cfe0","page-single":"31d6cfe0","pages":"31d6cfe0","rounds":"31d6cfe0","tools":"69a56e0e","topic":"0935d82a","topics":"891b0be8","video":"31d6cfe0","video-reimport":"31d6cfe0","videos":"31d6cfe0","weights":"fdb09c8f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
